import React, { useEffect }  from 'react';
import WOW from "wowjs";
import { Link } from 'react-router-dom';


function TestimonialsThree() {
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false, // This disables continuous scanning for new elements
        });
        wow.init();
      }, []);
  return (
    <div>
        

        <>
    {/* Start Testimonial with brand Area  */}
    <div className="testimonial-with-brand bg-1 bg_image">
        <div className="testimonial-area testimonial-style-three tmp-section-gap">
        <div className="container">
            <div className="row">
            <div className="col-lg-12">
                <div className="section-head">
                <div className="section-sub-title justify-content-center">
                    <span className="subtitle color-gradiant">
                    Clients Testimonial
                    </span>
                </div>
                <h2 className="title split-collab">What clients have to say</h2>
                </div>
            </div>
            </div>
            <div className="row g-5">
            <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".1s">
                <div className="tmp-testimonial-box style-three">
                <div className="testimonial-top">
                    <div className="rating rating-style-three">
                    <div className="stars-group">
                        <div className="star">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star-half-stroke" />
                        </div>
                    </div>
                    </div>
                    <div className="icon">
                    <i className="fa-duotone fa-quote-right" />
                    </div>
                </div>
                <div className="testimonial-body">
                    <p className="description">
                    It’s incredible. it’s really wonderful. bcom has completely
                    surpassed our expect. Urna porttitor rhoncus dolor purus non
                    enim praesent at the facilisis lectus.
                    </p>
                </div>
                <div className="clint-info-wrapper">
                    <Link to="#" className="thumbnail">
                    <img
                        src="assets/images/testimonial/testimonial-sm-img.png"
                        alt="Corporate Business"
                    />
                    </Link>
                    <div className="client-info">
                    <Link to="#">
                        <h5 className="title">Brooklyn Simmon</h5>
                    </Link>
                    <span className="designation">CEO, Bribbble LLC</span>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                <div className="tmp-testimonial-box style-three">
                <div className="testimonial-top">
                    <div className="rating rating-style-three">
                    <div className="stars-group">
                        <div className="star">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star-half-stroke" />
                        </div>
                    </div>
                    </div>
                    <div className="icon">
                    <i className="fa-duotone fa-quote-right" />
                    </div>
                </div>
                <div className="testimonial-body">
                    <p className="description">
                    It’s incredible. it’s really wonderful. bcom has completely
                    surpassed our expect. Urna porttitor rhoncus dolor purus non
                    enim praesent at the facilisis lectus.
                    </p>
                </div>
                <div className="clint-info-wrapper">
                    <Link to="#" className="thumbnail">
                    <img
                        src="assets/images/testimonial/testimonial-sm-img-1.png"
                        alt="Corporate Business"
                    />
                    </Link>
                    <div className="client-info">
                    <Link to="#">
                        <h5 className="title">Maxciko Alex</h5>
                    </Link>
                    <span className="designation">UI Designer</span>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".3s">
                <div className="tmp-testimonial-box style-three">
                <div className="testimonial-top">
                    <div className="rating rating-style-three">
                    <div className="stars-group">
                        <div className="star">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star-half-stroke" />
                        </div>
                    </div>
                    </div>
                    <div className="icon">
                    <i className="fa-duotone fa-quote-right" />
                    </div>
                </div>
                <div className="testimonial-body">
                    <p className="description">
                    It’s incredible. it’s really wonderful. bcom has completely
                    surpassed our expect. Urna porttitor rhoncus dolor purus non
                    enim praesent at the facilisis lectus.
                    </p>
                </div>
                <div className="clint-info-wrapper">
                    <Link to="#" className="thumbnail">
                    <img
                        src="assets/images/testimonial/testimonial-sm-img-2.png"
                        alt="Corporate Business"
                    />
                    </Link>
                    <div className="client-info">
                    <Link to="#">
                        <h5 className="title">Esther Howard</h5>
                    </Link>
                    <span className="designation">Web Developer</span>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div className="brand-area tmp-section-gapBottom">
        <div className="container">
            <div className="row">
            <div className="col-lg-12">
                <div className="brand-inner tmp-section-gapTop">
                <ul className="brand-list brand-style-1 justify-content-center justify-content-lg-between">
                    <li>
                    <Link to="#">
                        <img className="wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".1s"
                        src="assets/images/brand/brand-1.png"
                        alt="Brand Image"
                        />
                    </Link>
                    </li>
                    <li>
                    <Link to="#">
                        <img className="wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        src="assets/images/brand/brand-2.png"
                        alt="Brand Image"
                        />
                    </Link>
                    </li>
                    <li>
                    <Link to="#">
                        <img className="wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".3s"
                        src="assets/images/brand/brand-3.png"
                        alt="Brand Image"
                        />
                    </Link>
                    </li>
                    <li>
                    <Link to="#">
                        <img className="wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".4s"
                        src="assets/images/brand/brand-4.png"
                        alt="Brand Image"
                        />
                    </Link>
                    </li>
                    <li>
                    <Link to="#">
                        <img className="wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".4s"
                        src="assets/images/brand/brand-5.png"
                        alt="Brand Image"
                        />
                    </Link>
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    {/* End Testimonial with brand Area  */}
    </>


    </div>
  )
}

export default TestimonialsThree